function isDomesticCookieSetToTrue() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.startsWith("domestic=")) {
      var cookieValue = cookie.split("=")[1];
      if (cookieValue === "true") {
        // The "domestic" cookie is set to true
        return true;
      }
    }
  }
  // The "domestic" cookie is not set to true
  return false;
}
var random = document.querySelector(".random-text");
var button = document.querySelector(".button-us-link");
const isAdmin = JSON.parse(
  document.querySelector("[data-isAdmin]").getAttribute("data-isAdmin")
);
console.log("isAdmin:", isAdmin);
function onRedirectionCheck(country_name) {
  if (country_name == "United States") {
    setTimeout(function open(event) {
      if (document.querySelector(".display-none")) {
        document.querySelector(".display-none").style.display = "block";
        document.querySelector("body").style.overflow = "hidden";
        random.innerHTML = " We noticed you’re shopping from USA";
        button.innerText = "Continue to US Website";
      }
    }, 1000);
  } else if (country_name != "India" && country_name != "United States") {
    document.querySelector(".display-none").style.display = "block";
    document.querySelector("body").style.overflow = "hidden";
    random.innerHTML = `We noticed you’re shopping from ${country_name}`;
    button.innerText = "Continue to Global Website";
  } else {
    document.querySelector(".display-none").style.display = "none";
  }
}

if (!isAdmin) {
  fetch("https://www.chumbak.com/browsing_context_suggestions.json")
    .then((data) => data.json())
    .then((result) => {
      onRedirectionCheck(result.detected_values.country_name);
    });
}